import { render } from "./ylyTitle.vue?vue&type=template&id=15d26feb&scoped=true"
import script from "./ylyTitle.vue?vue&type=script&lang=js"
export * from "./ylyTitle.vue?vue&type=script&lang=js"

import "./ylyTitle.vue?vue&type=style&index=0&id=15d26feb&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d26feb"]])

export default __exports__